import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { MedicalCardDocuments } from "./documents";
import { MedicalCardInfo } from "./info";

const MedicalCard: React.FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <Tabs>
                <TabList>
                    <Tab>{ t("patients.medicalCards.detailsTab.title") }</Tab>
                    <Tab>{ t("patients.medicalCards.documentsTab.title") }</Tab>
                </TabList>

                <TabPanels>
                    <TabPanel>
                        <MedicalCardInfo />
                    </TabPanel>
                    <TabPanel>
                        <MedicalCardDocuments />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </>
    );
};

export default MedicalCard;
